/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// react-redux
import { useSelector } from 'react-redux'
// react router
import { useHistory } from "react-router-dom";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";

function CardsHeader({ name, parentName }) {
  const checklistState = useSelector(state => state.checklists);
  const filterState = useSelector(state => state.filter);
  const userState = useSelector(state => state.user);
  
  const history = useHistory();

  return (
    <>
      <div className="header bg-info pb-6">
        <Container fluid>
          <div className="header-body">
            <Row className="align-items-center py-4">
              <Col xs="12">
                <h6 className="h2 text-white d-inline-block mb-0">{`${name}${filterState.filter.franchise ? (name === '' ? '' : ' : ') + filterState.filter.franchise : ''}${filterState.filter.address ? ' | ' + filterState.filter.address : ''}`}</h6>{" "}
              </Col>
            </Row>

            <Row>
              <Col md="6" xl="3">
                <Card className="card-stats">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Very Satisfied Reports
                        </CardTitle>
                        {
                        userState.user.role === 'owner' && userState.user.plan === 'free' ?
                          (
                            <Button
                              className="mt-2"
                              color="primary"
                              size="sm"
                              onClick={e => history.push("/admin/billing")}
                            >
                              Upgrade to Pro
                            </Button>
                          ) :
                          (
                            <span className="h2 font-weight-bold mb-0">
                              {checklistState.statistics.additionalFeedback.totalFeedback === 0 || !checklistState.customerSatisfactionChart ? '0%' : Math.round((checklistState.customerSatisfactionChart.datasets[0].data[0] * 100 / checklistState.statistics.additionalFeedback.totalFeedback )* 10) / 10 + '%'}
                            </span>
                          )
                        }
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                          <i className="fas fa-smile" />
                        </div>
                      </Col>
                    </Row>
                    {/* <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-success mr-2">
                        <i className="fa fa-arrow-up" /> 3.48%
                      </span>{" "}
                      <span className="text-nowrap">Since last month</span>
                    </p> */}
                  </CardBody>
                </Card>
              </Col>
              <Col md="6" xl="3">
                <Card className="card-stats">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          % Checklists passed
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{checklistState.statistics.checklistsPassed === 0 ? '0%' : Math.round(checklistState.statistics.checklistsPassed * 100 / checklistState.statistics.totalChecklists * 10) / 10 + '%'}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                          <i className="fas fa-check-circle" />
                        </div>
                      </Col>
                    </Row>
                    {/* <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-danger mr-2">
                        <i className="fas fa-arrow-down" /> 3.48%
                      </span>{" "}
                      <span className="text-nowrap">Since last week</span>
                    </p> */}
                  </CardBody>
                </Card>
              </Col>
              <Col md="6" xl="3">
                <Card className="card-stats">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          % Checklists on Time
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{checklistState.statistics.completedOnTime === 0 ? '0%' : Math.round(checklistState.statistics.completedOnTime * 100 / checklistState.statistics.totalChecklists * 10) / 10 + '%'}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-yellow text-white rounded-circle shadow">
                          <i className="fas fa-clock" />
                        </div>
                      </Col>
                    </Row>
                    {/* <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-warning mr-2">
                        <i className="fas fa-arrow-down" /> 1.10%
                      </span>{" "}
                      <span className="text-nowrap">Since yesterday</span>
                    </p> */}
                  </CardBody>
                </Card>
              </Col>
              <Col md="6" xl="3">
                <Card className="card-stats">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          % Checklists Completed
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{checklistState.statistics.completed === 0 ? '0%' : Math.round(checklistState.statistics.completed * 100 / checklistState.statistics.totalChecklists * 10) / 10 + '%'}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                          <i className="fas fa-percent" />
                        </div>
                      </Col>
                    </Row>
                    {/* <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-success mr-2">
                        <i className="fas fa-arrow-up" /> 12%
                      </span>{" "}
                      <span className="text-nowrap">Since last month</span>
                    </p> */}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
}

CardsHeader.propTypes = {
  name: PropTypes.string,
  parentName: PropTypes.string,
};

export default CardsHeader;
